import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-product-benefits',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './product-benefits.component.html',
    styleUrl: './product-benefits.component.scss',
})
export class ProductBenefitsComponent {
    @Input() isDGPBenifts: boolean = false;
    @Input() isAboutUs: boolean = false;
}
